import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  BrainEstreamComputeRequest,
  BrainEstreamComputeResponse,
} from 'brain-data/model/brain-estream-compute.model';

@Injectable({ providedIn: 'root' })
export class BrainEstreamComputeService {
  constructor(private http: HttpClient) {}

  compute(request: BrainEstreamComputeRequest): Observable<BrainEstreamComputeResponse> {
    const payload: BrainEstreamComputeRequest = {
      ...request,
      contractNumber: request.contractNumber.trim(),
    };
    return this.http.post<BrainEstreamComputeResponse>(
      `${environment.apiBaseUrl}/brain/diff/contracts/compute`,
      payload,
    );
  }
}
